import styled from "styled-components";

export const TextFieldAlignDiv = styled.div`
  width: 100%;
`;
